var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanctionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7608 3.64348L19.0009 4.3H19.7H26.6667C27.9572 4.3 29 5.34674 29 6.6V29.7C29 30.9533 27.9572 32 26.6667 32H3.33333C2.04279 32 1 30.9533 1 29.7V6.6C1 5.34674 2.04279 4.3 3.33333 4.3H10.3H10.9991L11.2392 3.64348C11.8018 2.10509 13.2727 1 15 1C16.7273 1 18.1982 2.10509 18.7608 3.64348ZM10.9631 27.1107L11.6667 27.8072L12.3702 27.1107L25.7035 13.9107L26.4188 13.2025L25.7061 12.4918L23.3561 10.1488L22.6525 9.44737L21.9465 10.1463L11.6653 20.3247L8.05217 16.7615L7.34864 16.0677L6.64645 16.7628L4.29646 19.0893L3.57863 19.8L4.29646 20.5107L10.9631 27.1107ZM17.6667 4.95C17.6667 3.48076 16.4595 2.3 15 2.3C13.5405 2.3 12.3333 3.48076 12.3333 4.95C12.3333 6.41924 13.5405 7.6 15 7.6C16.4595 7.6 17.6667 6.41924 17.6667 4.95Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanctionIcon);
export default __webpack_public_path__ + "static/media/SanctionIcon.41ec9d5c611a630fe10753f10b0e67e0.svg";
export { ForwardRef as ReactComponent };